import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {PageContainerComponent} from '@components/pages/page-container/page-container.component';
import {AuthorizationGuardService} from 'src/app/shared/authorization-guard/authorization-guard.service';
import {
  StatusEventPageContainerComponent
} from '@components/pages/page-container/status-event-page/status-event-page-container.component';
import {FramePageContainerComponent} from '@components/pages/page-container/frame-page/frame-page-container.component';
import {
  InteractiveDataAnalysisContainerComponent
} from '@components/pages/page-container/interactive-data-analysis/interactive-data-analysis-container.component';
import {
  UserDefinedPageContainerComponent
} from '@components/pages/page-container/user-defined-page-container/user-defined-page-container.component';
import {
  TableauPageContainerComponent
} from '@components/pages/page-container/tableau-page/tableau-page-container.component';
import {FormPageContainerComponent} from '@components/pages/page-container/form-page/form-page-container.component';
import {BucketBrowserContainerComponent} from '@components/pages/page-container/bucket-browser-page/bucket-browser-container.component';
import {USER_ROLE} from '@constants/user-role.constant';
import {
  StatusEventGroupPageContainerComponent
} from '@components/pages/page-container/status-event-group-page-container/status-event-group-page-container.component';

const routes: Routes = [
  {
    path: 'page/:details',
    component: PageContainerComponent,
    canActivate: [AuthorizationGuardService]
  },
  {
    path: 'statusEventPage/:details',
    component: StatusEventPageContainerComponent,
    canActivate: [AuthorizationGuardService],
    data: {isTemplate: false}
  },
  {
    path: 'templateStatusEventPage/:details',
    component: StatusEventPageContainerComponent,
    canActivate: [AuthorizationGuardService],
    data: {isTemplate: true}
  },
  {
    path: 'statusEventGroupPage/:details',
    component: StatusEventGroupPageContainerComponent,
    canActivate: [AuthorizationGuardService]
  },
  {
    path: 'tableauPage/:details',
    component: TableauPageContainerComponent,
    canActivate: [AuthorizationGuardService],
    data: {roles: [USER_ROLE.ANALYTICS, USER_ROLE.ADMIN, USER_ROLE.TECH_ADMIN, USER_ROLE.SUPERADMIN]}
  },
  {
    path: 'framePage/:details',
    component: FramePageContainerComponent,
    canActivate: [AuthorizationGuardService]
  },
  {
    path: 'interactiveDataAnalysis/:details',
    component: InteractiveDataAnalysisContainerComponent,
    canActivate: [AuthorizationGuardService]
  },
  {
    path: 'userDefinedPage/:details',
    component: UserDefinedPageContainerComponent,
    canActivate: [AuthorizationGuardService],
    data: {isTemplate: false}
  },
  {
    path: 'formPage/:details',
    component: FormPageContainerComponent,
    canActivate: [AuthorizationGuardService]
  },
  {
    path: 'bucketBrowser/:details',
    component: BucketBrowserContainerComponent,
    canActivate: [AuthorizationGuardService]
  },
  {
    path: 'templateUserDefinedPage/:details',
    component: UserDefinedPageContainerComponent,
    canActivate: [AuthorizationGuardService],
    data: {isTemplate: true}
  },
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forRoot(routes)
  ]
})
export class PagesRoutingModule {
}
